import { PRIVACY_POLICY_DOCUMENT } from "@-/dev.improve.haniverse.lib.legal";
import { LegalDocumentPage } from "#legal-document-page";

/** The public Privacy Policy at `/privacy`, rendered on web only. */
export function PrivacyPolicyPage() {
  return (
    <LegalDocumentPage
      description="How Haniverse collects, uses and protects information when you use the app."
      document={PRIVACY_POLICY_DOCUMENT}
    />
  );
}
